import { render, staticRenderFns } from "./ProtocolPage.vue?vue&type=template&id=513f224e&scoped=true"
import script from "./ProtocolPage.vue?vue&type=script&lang=js"
export * from "./ProtocolPage.vue?vue&type=script&lang=js"
import style0 from "./ProtocolPage.vue?vue&type=style&index=0&id=513f224e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f224e",
  null
  
)

export default component.exports